<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="27" height="23" viewBox="0 0 27 23" fill="none">
	  <path d="M25.77 5.15977C25.24 4.38977 24.39 3.91977 23.46 3.86977L7.42 3.02977L7.3 2.41977C7.02 1.01977 5.78 0.00976562 4.36 0.00976562H1C0.45 0.00976562 0 0.459766 0 1.00977C0 1.55977 0.45 2.00977 1 2.00977H4.36C4.84 2.00977 5.25 2.34977 5.34 2.80977L7.54 13.7898C7.91 15.6498 9.56 17.0098 11.46 17.0098H20.28C22.02 17.0098 23.56 15.8898 24.09 14.2298L26.16 7.78977C26.45 6.89977 26.31 5.93977 25.77 5.16977V5.15977ZM24.25 7.16977L22.18 13.6098C21.91 14.4398 21.15 14.9998 20.28 14.9998H11.46C10.51 14.9998 9.69 14.3198 9.5 13.3898L7.83 5.03977L23.36 5.85977C23.67 5.87977 23.95 6.02977 24.13 6.28977C24.31 6.54977 24.35 6.86977 24.26 7.15977L24.25 7.16977Z"  :fill="fill" :class="$attrs.class"/>
	  <path d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z"  :fill="fill" :class="$attrs.class"/>
	  <path d="M20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23Z"  :fill="fill" :class="$attrs.class"/>
	</svg>
</template>


<script setup>
	const props = defineProps({
	  fill: {
	    type: String,
	    default: 'currentColor'
	  }
	})
</script>